import { rucksack, colors } from '@black-bear-energy/rucksack'

export const statusChipColors: Record<
  | 'derisking'
  | 'ntp'
  | 'construction'
  | 'complete'
  | 'preRFP'
  | 'rfp'
  | 'contract',
  { color: string; backgroundColor: string }
> = {
  derisking: {
    color: colors.teal[900],
    backgroundColor: '#72E4C9',
  },
  ntp: {
    color: colors.blue[900],
    backgroundColor: colors.blue[200],
  },
  construction: {
    color: colors.green[900],
    backgroundColor: colors.green['A100'],
  },
  complete: {
    color: rucksack.palette.primary.chipLabel,
    backgroundColor: rucksack.palette.primary.chipFill,
  },
  preRFP: {
    color: rucksack.palette.text.primary,
    backgroundColor: rucksack.palette.action.selected,
  },
  rfp: {
    color: rucksack.palette.secondary.chipLabel,
    backgroundColor: rucksack.palette.secondary.chipFill,
  },
  contract: {
    color: colors.indigo[900],
    backgroundColor: '#9EADFF',
  },
}
